const DataTable = require('../util/data-table');

var MealsBuild = function(el, opts) {
    this.$el = el instanceof jQuery ? el : $(el);
    this.options = opts || {};
    this.init();
};

MealsBuild.prototype = {
    constructor: MealsBuild,
    $el: undefined,
    options: undefined,
    init: function() {
        var self = this;

        // window.mealsBuildQueryParams = function(params) { return self.queryParams(params); };

        self.$el.find('[data-bs-toggle="tab"]').on('shown.bs.tab', function() {
            $(window).trigger('resize');
        });

        self.$el.find('.select-all,.deselect-all').on('click', function(e) {
            self.$el.find('.tab-pane.active').find('tbody tr td:first-child [type="checkbox"]').prop(
                'checked',
                $(e.currentTarget).hasClass('select-all') ? true : false
            );
            self.$el.find('.tab-pane.active').find('tbody tr td:first-child [type="checkbox"]').trigger('change');
        });

        self.$el.on('change', 'tbody tr td:first-child [type="checkbox"]', function() {
            var $this = $(this);
            $this.closest('tr')[$this.prop('checked') ? 'addClass' : 'removeClass']('selected');
        });

        self.initTable();
    },
    queryParams: function(params) {
        params.category = this.currentCategory;
        return params;
    },
    initTable: function() {
        var self = this;
        self.$el.find('[data-bs-table]').each(function() {
            var dt = new DataTable(this, {
                // height: '500px'
                height: 500
            });
        });
    }
};

module.exports = MealsBuild;